import { Box, Grid, Stack, useTheme, Typography, Link, Accordion, AccordionSummary, Chip, AccordionDetails, TableHead, TableRow, TableCell, IconButton, TableBody, Table, Tooltip } from "@mui/material";
import FormStepper from "../../common/FormStepper";
import React, { useEffect, useMemo, useRef, useState } from "react";
import PracticeEditViewForm from "./PracticeEditViewForm";
import MuiCustomTable from "../../common/CustomTable";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../common/Button";
import {
  AddCircleOutlineOutlined,
  CancelOutlined,
  Delete,
  DoDisturbAltOutlined,
  DownloadOutlined,
  Edit,
  ExpandMore,
  FileOpenOutlined,
  ModeOutlined,
  PersonAddAltOutlined,
  DescriptionOutlined,
  TrackChanges,
  GroupsOutlined,
  PlaceOutlined,
  LocalHospitalOutlined,
} from "@mui/icons-material";
import { addAuthorizedProviderUserData, deleteAuthorizedProviderUserById, editAuthorizedProviderUserData, fetchAllAuthorizedProviderUserData, fetchPracticeByIdData, fetchPracticeTemplatesData, PracticeTemplateInfo, PracticeTemplateRow, resetPracticeEditInfo, usePracticeEditSlice, inactivatePracticeTemplateData } from "../../../redux/slice/practice/practiceEditSlice";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
  usePracticeLocationsSlice,
  fetchPracticeLocationsData,
  PracticeLocationInfo,
  savePracticeLocations,
  inactivePracticeLocation,
  resetPracticeLocationsInfo,
} from "../../../redux/slice/practice/practiceLocationSlice";
import {
  usePracticeProvidersSlice,
  fetchPracticeProvidersData,
  PracticeProviderInfo,
  savePracticeProviders,
  inactivePracticeProvider,
  resetPracticeProvidersInfo,
  fetchUsedPracticeProviderIDs,
} from "../../../redux/slice/practice/practiceProvidersSlice";
import {
  usePracticeProductsSlice,
  fetchPracticeProductsData,
} from "../../../redux/slice/practice/practiceProductSlice";
import CustomAlert from "../../common/CustomAlert";
import PracticeLocationPopup, { initialState } from "./PracticeLocationPopup";
import ProviderPopup, { providerInitialState } from "./ProviderPopup";
import moment from "moment";
import {
  MainErrorInfo,
  SingleAlertInfo,
  setMainErrorObj,
  setSingleAlertObj,
} from "../../../redux/slice/commonSlice";
import BillerInfoEditViewForm from "./BillerInfoEditViewForm";
import PracticeExecutiveInfoViewForm from "./PracticeExecutiveInfoViewForm";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import { Controller, useForm } from "react-hook-form";
import LegacyToolBar from "../../common/LegacyToolBar";
import { CAN_ACCESS_APPLICATION, PRACTICE_STATUS, PROVIDER_USER_ACTION_BUTTON, USER_ROLE_ENTITY_NAMES, USER_ROLES } from "../../../constants/applicationConstants";
import { selectIsValueFoundInToken, setSelectedModule, useAuthSlice } from "../../../redux/slice/authSlice";
import CustomIconButton from "../../common/CustomIconButton";
import { tokens } from "../../../theme";
import AuthorizedSignerPopup, { AuthorizedSignerInfo } from "./AuthorizedSignerPopup";
import ErrorDialog from "../../common/ErrorDialog";
import { fetchDocumentById, fetchTemplateById, inactiveAuthorizedSigner, PracticeInfo, saveAuthorizedSigners, usePracticeSlice } from "../../../redux/slice/practiceSlice";
import PDFViewer from "../../common/pdf/PDFViewer";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useNavigation } from "../../../hooks/useNavigation";
import { AgencyOption, CreateSearchAgency, editAgencyProductCommission, fetchActiveAgencyExecutives, fetchAssociateAgencyList, getOverrideAgencyCommissions, getPracticeListByUserRoleInAgency, useAgencyReducer } from "../../../redux/slice/agency/AgencySlice";
import ProductCommissionPopup from "../agency/ProductCommissionPopup";
import { fetchProductsByUserRoleData, ProductInfo, useProductListReducer } from "../../../redux/slice/product/productListSlice";
import { downloadBase64File, fullName, sortNames } from "../../../utils/Utility";
import { hasProductIdOverlap, isDateBetween, isDateEarlier, isSameRecord, Row } from "../agency/AgencyForm";
import BorderedSection from "../../common/BorderedSection";
import CustomTable from "../../common/CustomTable";
import AuthorisedUserPopup from "./AuthorizedUserPopup";
import AuthorizedUserPopup from "./AuthorizedUserPopup";
import PracticeTemplatePopup, { EditPracticeTemplateData } from "./PracticeTemplatePopup";
import { SectionHeader } from "../../ui/ContentSection";
import SectionTabNav, { SectionTabItem } from "../../common/SectionTabNav";
import { useModalStyles } from "../../common/useModalStyles";
import { useListPageStyles } from "../../common/useListPageStyles";


//CS-1234 - Start
export type Option = {
  value: string,
  label: string
};

export type ProductCommissionAgency = {
  rowIndex: any;
  productCommissionId: number | undefined;
  productId: any | undefined;
  productName: string | undefined;
  associateType: string | undefined;
  agencyId: number | undefined;
  associateAgencyId: number | undefined;
  associatePracticeId: number | undefined;
  associatePracticeName?: string | undefined;
  associateAccountRepId: number | undefined;
  associateAccountRepName?: string | undefined;
  commissionRate: number | string | undefined;
  commissionPayTerms: string | undefined;
  effectiveDate: string | undefined;
  inactiveDate: string | undefined;
  associateAgencyName?: string | undefined;
  associateEntityName?: string | undefined;
  agencyName?: string | undefined;
}
//CS-1234 - End
type PopupMode = 'create' | 'edit';
const PracticeEditView = () => {
  interface Column {
    id: string;
    label: string;
    minWidth?: number;
    align?: "right" | "center" | "left";
    format?: (value: number) => string;
  }

  const columns: Column[] = [
    {
      id: "combinedAddress",
      label: "Practice Location Address",
      minWidth: 100,
    },
    { id: "billingAddress", label: "Billing Address", minWidth: 100 },
    {
      id: "action",
      label: "Action",
      minWidth: 100
    },
    { id: "modifiedInactiveDate", label: "Inactive Date", minWidth: 100 },
  ];

  const columns2: Column[] = [
    { id: "fullName", label: "Provider Name", minWidth: 120 },
    { id: "npi", label: "NPI", minWidth: 100 },
    { id: "ptan", label: "PTAN", minWidth: 100 },
    { id: "taxId", label: "TAX ID", minWidth: 100 },
    { id: "email", label: "Email", minWidth: 200 },
    { id: "userCreated", label: "User Created", minWidth: 100 },
    {
      id: "action",
      label: "Action",
      minWidth: 100,
    },
    { id: "modifiedInactiveDate", label: "Inactive Date", minWidth: 100 },
  ];

  const columns3: Column[] = [
    { id: "productName", label: "Product Name", minWidth: 100 },
    { id: "agreementStatus", label: "Agreement Status", minWidth: 100 },
    {
      id: "action",
      label: "Action",
      minWidth: 170,
      align: "center",
    },
  ];

  const columns4: Column[] = [
    { id: "fullTitleName", label: "Full Name", minWidth: 100 },
    { id: "email", label: "Email", minWidth: 100 },
    { id: "isOwner", label: "Ownership", minWidth: 100 },
    { id: "position", label: "Position", minWidth: 100 },
    { id: "action", label: "Action", minWidth: 50 },
    { id: "inactiveDate", label: "Inactive Date", minWidth: 100 },
  ];
  const columns5: Column[] = [
    { id: "provider", label: "Provider", minWidth: 100 },
    { id: "authorisedUser", label: "Authorised User", minWidth: 100 },
    { id: "emailNotification", label: "Email Notification", minWidth: 100 },
    { id: "addedModifiedBy", label: "Added/Modified By", minWidth: 100 },
    { id: "addedModifiedAt", label: "Added/Modified At", minWidth: 100 },
    { id: "action", label: "Action", minWidth: 100 },
  ];

  //CS-1234 - Start
  const overrideEntityColumns: Column[] = [
    { id: "productName", label: "Product", minWidth: 100 },
    { id: "effectiveDate", label: "Effective Date", minWidth: 100 },
    { id: "inactiveDate", label: "Inactive Date", minWidth: 100 },
    { id: "overrideAgency", label: "Override Agency", minWidth: 100 },
    { id: "commissionRate", label: "Service Fee", minWidth: 100 },
    { id: "associateEntityName", label: "Associate Entity", minWidth: 100 },
    { id: "associateAgencyCommission", label: "Associate Entity Svc Fee", minWidth: 100, format: (value: number) => { return value + " %" } },
    { id: "action", label: "Action", minWidth: 50 },
  ];
  //CS-1234 - End

  const [activeStep, setActiveStep] = React.useState<number>(0);
  const [activeTableTab, setActiveTableTab] = React.useState<string>("");
  const { navigate } = useNavigation();
  const dispatch = useAppDispatch();
  const { practiceEditInfo ,practiceTemplateData ,providerAuthorizedUserData } = usePracticeEditSlice();
  const { practiceProvidersInfo, usedPracticeProviderIds } = usePracticeProvidersSlice();
  const { practiceProductsInfo } = usePracticeProductsSlice();
  const { practiceLocationsInfo } = usePracticeLocationsSlice();
  const [isAlertShow, setIsAlertShow] = React.useState(false);
  const [showLocationPopup, setShowLocationPopup] = React.useState(false);
  const [showProviderPopup, setShowProviderPopup] = React.useState(false);
  const [provider, setProvider] = React.useState<PracticeProviderInfo[]>([]);
  const [locationItemObject, setLocationItemObject] =
    React.useState<PracticeLocationInfo>(initialState);
  const [providerItemObject, setProviderItemObject] =
    React.useState<PracticeProviderInfo>(providerInitialState);
  const [inactiveLocation, setInactiveLocation] = React.useState<{
    message: string;
    show: boolean;
    row: any;
  }>({ message: "", show: false, row: "" });
  const [inactiveProvider, setInactiveProvider] = React.useState<{
    message: string;
    show: boolean;
    row: any;
  }>({ message: "", show: false, row: "" });
  const { getValues , setError } = useForm();
  const { userInfo } = useAuthSlice();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const {
    tokens: mTokens,
    isDark: isDarkModal,
    cancelBtnSx,
  } = useModalStyles();
  const { tableSx } = useListPageStyles();
  const cardSx = {
    borderRadius: "16px",
    border: `1px solid ${mTokens.border}`,
    backgroundColor: mTokens.bg,
    backgroundImage: "none",
    overflow: "hidden" as const,
    boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
  };
  const sectionBodySx = { px: { xs: 1.25, md: 2 }, py: 1.25 };
  // Mirrors PatientDetails.tsx: shared list-page table chrome, but the Action column
  // keeps CustomIconButton's own semantic colours instead of a flat grey.
  const woundTableWrapSx = {
    ...tableSx,
    mt: 0,
    "& .MuiTableHead-root .MuiTableCell-root": {
      ...(tableSx["& .MuiTableHead-root .MuiTableCell-root"] as object),
      background: "transparent !important",
      // Plain-text head cells (the Authorized Users table) have no Typography to colour.
      color: "#00B8D9",
      fontSize: "0.78rem",
      fontWeight: 800,
      letterSpacing: "0.02em",
    },
    "& .MuiTableBody-root .MuiTableCell-root[colspan]": {
      py: 3.5,
      borderBottom: "none",
    },
    "& .MuiTableBody-root .MuiTableCell-root[colspan] .MuiTypography-root": {
      color: mTokens.textSecondary,
      fontSize: "0.85rem",
      fontWeight: 600,
    },
    "& .MuiIconButton-root": {
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: isDarkModal ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)",
      },
    },
  };
  // Matches the "View all IVRS" chrome on Patient Details. Takes a hex so the
  // Locations/Providers buttons can still flag an all-inactive table in red.
  const sectionActionBtnSx = (hex: string = mTokens.accent) => ({
    textTransform: "none" as const,
    fontWeight: 700,
    fontSize: "0.82rem",
    borderRadius: "10px",
    height: 36,
    px: 1.6,
    color: hex,
    borderColor: hex,
    backgroundColor: "transparent",
    whiteSpace: "nowrap" as const,
    letterSpacing: "0.04em",
    "&:hover": {
      backgroundColor: `${hex}14`,
      borderColor: hex,
      boxShadow: "none",
    },
    "& .MuiTypography-root": { color: `${hex} !important`, fontWeight: 700 },
    "& .MuiButton-startIcon, & .MuiSvgIcon-root": { color: hex },
  });
  const outlineAccentBtnSx = {
    textTransform: "none" as const,
    fontWeight: 700,
    fontSize: "0.82rem",
    borderRadius: "10px",
    minHeight: 40,
    height: "auto",
    py: 1,
    px: 1.6,
    boxSizing: "border-box",
    overflow: "visible",
    color: mTokens.accent,
    borderColor: mTokens.accent,
    backgroundColor: "transparent",
    whiteSpace: "nowrap" as const,
    "& .MuiTypography-root": { color: "inherit", fontWeight: 700, lineHeight: 1.2 },
    "&:hover": {
      backgroundColor: `${mTokens.accent}14`,
      borderColor: mTokens.accent,
    },
  };
  const footerCancelBtnSx = {
    ...cancelBtnSx,
    minHeight: 40,
    height: "auto",
    py: 1,
    boxSizing: "border-box",
    overflow: "visible",
    "& .MuiTypography-root": { fontWeight: 700, lineHeight: 1.2 },
  };
  const isAdminUser = userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN;
  // The tables were previously stacked on one very long page; they are now grouped
  // into tabs so only the set the user asked for is rendered.
  const tableTabs = useMemo<SectionTabItem[]>(() => {
    const tabs: SectionTabItem[] = [];
    if (isAdminUser) {
      tabs.push({ id: "templates", label: "Practice Templates", icon: <DescriptionOutlined fontSize="small" /> });
      tabs.push({ id: "override", label: "Override Entity", icon: <TrackChanges fontSize="small" /> });
    }
    tabs.push({ id: "signers", label: "Authorized Signers & Locations", icon: <GroupsOutlined fontSize="small" /> });
    tabs.push({ id: "authorizedUsers", label: "Authorized Users", icon: <PersonAddAltOutlined fontSize="small" /> });
    tabs.push({ id: "providers", label: "Providers", icon: <LocalHospitalOutlined fontSize="small" /> });
    return tabs;
  }, [isAdminUser]);
  const selectedTableTab = tableTabs.some((tab) => tab.id === activeTableTab)
    ? activeTableTab
    : (tableTabs[0]?.id || "");
  const [showAuthorizedSignerPopup, setShowAuthorizedSignerPopup] = React.useState(false);
  const location = useLocation();
  const [totalLocationAddressRows, setTotalLocationAddressRows] = React.useState(0);
  const canAccessPracticeActionsInactive = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPracticeActions", PRACTICE_STATUS.INACTIVATE)(state));
  //CS-1395
  const canAccessPracticeProviderUserActionsAddButton = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessProviderUserActions", PROVIDER_USER_ACTION_BUTTON.ADD)(state));
  const canAccessPracticeProviderUserActionsEditButton = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessProviderUserActions", PROVIDER_USER_ACTION_BUTTON.EDIT)(state));
  const canAccessPracticeProviderUserActionsDeleteButton = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessProviderUserActions", PROVIDER_USER_ACTION_BUTTON.DELETE)(state));
  const canAccessUsersList = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.USER_MANAGEMENT )(state));
  const canAccessProvidersList = useSelector((state: RootState) => selectIsValueFoundInToken("canManageUsers", USER_ROLES.ROLE_PROVIDER )(state));
  const [billingRows, setBillingRows] = React.useState(0);
  const [inactiveBillingRows, setInactiveBillingRows] = React.useState(0);
  const [locationError, setLocationError] = React.useState('');
  const [totalProvidersRows, setTotalProvidersRows] = React.useState(0);
  const [inactiveProvidersRows, setInactiveProvidersRows] = React.useState(0);
  const [providerError, setProviderError] = React.useState('');
  const [lastActiveProvider, setLastActiveProvider] = React.useState(false);
  const [practiceUpdated, setPracticeUpdated] = React.useState(false);
  const shouldShowConfirmButton = lastActiveProvider;
  const [showOptionPopup, setShowOptionsPopup] =
    useState<OptionPopupObjectProps>({ message: "", show: false });
  const [showPDF, setShowPDF] = useState(false);
  const { document } = usePracticeSlice(); 
  const [createProviderUser, setCreateProviderUser] = React.useState<{
    message: string;
    show: boolean;
    row: any;
  }>({ message: "", show: false, row: "" });
  const [inactiveSigner, setInactiveSigner] = React.useState<{
    message: string;
    show: boolean;
    row: any;
  }>({ message: "", show: false, row: "" });
  const [showAuthorizedUserPopup, setShowAuthorizedUserPopup] = useState<{
  open: boolean;
  mode: PopupMode;
  initialValues?: any;
}>({ open: false, mode: 'create' });
  const [showTemplatePopup, setShowTemplatePopup] = useState(false);
  const [templateEditData, setTemplateEditData] = useState<EditPracticeTemplateData | undefined>(undefined);
  const [isTemplateEditMode, setIsTemplateEditMode] = useState(false);

  //CS-1234 - Start
  const { overrideAgencyCommissionsList, associateAgencyList, agencyExecutives, practiceByUserRoleAgencySlice } = useAgencyReducer();
  const [editCommission, setEditCommission] = useState(false);
  const [selectedAssociateType, setSelectedAssociateType] = useState<any>('');
    const [selectedCommission, setSelectedCommission] = useState<Row>({
      productCommissionId: 0,
      productId: [],
      productName: undefined,
      associateType: undefined,
      associateAgencyId: undefined,
      associatePracticeId: undefined,
      associateAccountRepId: undefined,
      commissionRate: undefined,
      commissionPayTerms: undefined,
      associateAgencyName: undefined,
      associatePracticeName: undefined,
      associateAccountRepName: undefined,
      associateAgencyCommission: undefined,
      effectiveDate: undefined,
      inactiveDate: undefined,
      rowIndex: 1
    });
  const [open, setOpen] = useState(false);
  const { productsByUserRole } = useProductListReducer();
  const PRACTICE_ENTITY: string = "PRACTICE";
  const AGENCY_ENTITY: string = "AGENCY";
  const ACCOUNT_REPRESENTATIVE_ENTITY: string = "ACCOUNTREP";
  //CS-1234 - End

  //CS-1310 - Start
  const isDownloading = useRef(false);
   const columnsTemplate: Column[] = useMemo(() => {
      let columnArray: Column[] = [
        { id: "type", label: "Type"},
        { id: "docName", label: "Name", minWidth: 120 },
        { id: "description", label: "Description", minWidth: 120 },
        { id: "manufacturerName", label: "Manufacturer", minWidth: 120 },//CS-1518
        { id: "templateLevel", label: "Template Level", minWidth: 120 },//CS-1518
        { id: "inUse", label: "In Use", minWidth: 120 },
        { id: "inactiveDate", label: "Inactive Date" },
        { id: "action", label: "Actions" },
      ];
      return columnArray;
    },[]);

 const practiceTemplateRows: PracticeTemplateRow[] = useMemo(() => {
    const rows: PracticeTemplateRow[] = [];
    practiceTemplateData?.forEach(data => {
      const manufacturerName = data?.manufacturerName || 'N/A';
      const hasAsterisk = manufacturerName.includes('*');

      const row = {
        type: data.type,
        docName: data.fileName,
        description: data.description,
        inactiveDate: data.inactiveDate,
        templateId: data.templateId,
        manufacturerPracticeTemplateId: data.manufacturerPracticeTemplateId,//CS-1518
        manufacturerId: data?.manufacturerId,
        manufacturerName: hasAsterisk ? (
          <span>
            {manufacturerName.replace('*', '')}
            <Tooltip
              title={
                <Box
                  sx={{
                    padding: 2,
                    maxWidth: 400,
                    backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
                    borderRadius: 2,
                    boxShadow: theme.palette.mode === 'dark'
                      ? '0px 4px 8px rgba(0, 0, 0, 0.5)'
                      : '0px 4px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.8)' : '#322f2c',
                      lineHeight: 1.5,
                      letterSpacing: '0.02em',
                    }}
                  >
                    This template is used by more than one manufacturers.
                  </Typography>
                </Box>
              }
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
                    color: theme.palette.mode === 'dark' ? '#fff' : '#333',
                    boxShadow: theme.palette.mode === 'dark'
                      ? '0px 3px 6px rgba(0, 0, 0, 0.4)'
                      : '0px 3px 6px rgba(0, 0, 0, 0.08)',
                    borderRadius: '8px',
                    fontSize: '14px',
                    padding: 0,
                  },
                },
              }}
            >
              <span style={{  color: '#ff9800', fontWeight: 'bold' }}>*</span>
            </Tooltip>
          </span>
        ) : manufacturerName,//CS-1518
        templateLevel: data?.templateLevel || 'N/A',//CS-1518
        inUse: data.inactiveDate ? 'No' : 'Yes',
      }
      rows.push(row)
    })
    return rows;
  }, [practiceTemplateData]);

  //CS-1310 - End
  React.useEffect(() => {
    dispatch(resetPracticeProvidersInfo());
    //CS-1234 - Start
    dispatch(fetchAssociateAgencyList());
    dispatch(fetchUsedPracticeProviderIDs());
    dispatch(fetchProductsByUserRoleData(false));
    dispatch(fetchActiveAgencyExecutives({ getAgencyAdmins: true, isInactive: true }));
    dispatch(getPracticeListByUserRoleInAgency(true));
    //CS-1234 - End
    const practiceId = location?.state?.practiceId;
    if (practiceId){
      dispatch(fetchPracticeByIdData(practiceId)).then((res)=>{
        if (res.payload && res.payload.code === "V3OK" && res.payload.message === "SUCCESS"){
          dispatch(fetchPracticeLocationsData(practiceId));
          dispatch(fetchPracticeProvidersData(practiceId));
          dispatch(fetchPracticeProductsData(practiceId));
        }
      })
      dispatch(getOverrideAgencyCommissions(practiceId)); //CS-1234
      //CS-1310 - Fetch practice tempalte by practice id
      dispatch(fetchPracticeTemplatesData(practiceId))
      //CS-1310 - End
      //Cs-1395
      dispatch(fetchAllAuthorizedProviderUserData(practiceId))
    }
  }, []);

  useEffect(()=>()=>{
    dispatch(resetPracticeEditInfo());
    dispatch(resetPracticeLocationsInfo());
    dispatch(resetPracticeProvidersInfo());
    dispatch(fetchUsedPracticeProviderIDs());
  },[])

  // const handleEditActionLocation = (row: any) => {
  //   let isBillingAddress = "";
  //   if (row.locationType === "BILLING") {
  //     isBillingAddress = "yes";
  //   } else {
  //     isBillingAddress = "no";
  //   }
  //   const combinedObject = {
  //     ...row,
  //     isBillingAddress: isBillingAddress,
  //   };
  //   setLocationItemObject(combinedObject);
  //   setShowLocationPopup(true);
  // };

  const handleInactivateBillingAddress = (row: any) => {
    const lastActiveBillingAddress = row.locationType === "BILLING";
    if (lastActiveBillingAddress) {
      setInactiveLocation({
        message:
        "At least 1 billing address is required, please add a new billing address.",
        show: true,
        row: row,
      });

      let ErrObj: SingleAlertInfo = {
        message: "At least 1 billing address is required, please add a new billing address.",
        alertType: "error",
      };
      dispatch(setSingleAlertObj(ErrObj));

    } else {
      setInactiveLocation({
        message:
          "Do you really want to inactive this practice location? ",
        show: true,
        row: row,
      });

    };
  }

  const confirmInactiveLocation = () => {
    if (inactiveLocation.row && inactiveLocation.row.locationType === "BILLING") {
      setShowLocationPopup(true);
    } 
      handleDeleteActionLocation(inactiveLocation.row);
      setInactiveLocation({ message: "", show: false, row: null });
  };

  const cancelInactiveLocation = () => {
    setInactiveLocation({ message: "", show: false, row: "" });
  };

  const handleDeleteActionLocation = async (row: any) => {
    const currentDate = new Date();
    const formattedDate = moment(currentDate).format("MM/DD/YYYY");
    const data = {
      locationId: row.locationId,
      inactiveDate: formattedDate,
    };
    const response = await dispatch(inactivePracticeLocation(data));
    if (practiceEditInfo) {
      if (
        response.payload !== undefined &&
        response.payload.message === "SUCCESS"
      ) {
        let successObj: SingleAlertInfo = {
          message: "Practice Location Successfully Inactivated",
          alertType: "success",
        };
        setPracticeUpdated(true);
        dispatch(setSingleAlertObj(successObj));
        dispatch(fetchPracticeLocationsData(practiceEditInfo.practiceId));
      } else if (response.payload !== undefined && response.payload.message) {
        let errorObj: SingleAlertInfo = {
          message: response.payload.message,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      } else {
        let errorObj: SingleAlertInfo = {
          message: "Practice Location Inactive Failed.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      }
    }
  };

  // const handleEditActionProvider = (row: any) => {
  //   setProviderItemObject(row);
  //   setShowProviderPopup(true);
  // };

  const handleInactivateProvider = (row: any) => {
    if (lastActiveProvider) {
      setInactiveProvider({
        message:
          "At least 1 practice provider is required.",
        show: true,
        row: row,
      });
    } else{
      setInactiveProvider({
        message:
          "Do you really want to inactive this practice provider? ",
        show: true,
        row: row,
      });
    }
  }

  const confirmInactiveProvider = () => {
    handleDeleteActionProvider(inactiveProvider.row);
    setInactiveProvider({ message: "", show: false, row: "" });
  };

  const cancelInactiveProvider = () => {
    setInactiveProvider({ message: "", show: false, row: "" });
  };

  const handleDeleteActionProvider = async (row: any) => {
    const currentDate = new Date();
    const formattedDate = moment(currentDate).format("MM/DD/YYYY");
    const data = {
      providerId: row.providerId,
      inactiveDate: formattedDate,
    };
    const response = await dispatch(inactivePracticeProvider(data));
    if (practiceEditInfo) {
      if (
        response.payload !== undefined &&
        response.payload.message === "SUCCESS"
      ) {
        let successObj: SingleAlertInfo = {
          message: "Practice Provider Successfully Inactivated",
          alertType: "success",
        };
        setPracticeUpdated(true);
        dispatch(setSingleAlertObj(successObj));
        dispatch(fetchPracticeProvidersData(practiceEditInfo.practiceId));
      } else if (response.payload !== undefined && response.payload.message) {
        let errorObj: SingleAlertInfo = {
          message: response.payload.message,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      } else {
        let errorObj: SingleAlertInfo = {
          message: "Practice Provider Inactive Failed.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      }
    }
  };

  const handleCreateProviderUser = async (row: any) => {
    setCreateProviderUser({
      message:
        "Do you wish to create a user account for this practice provider? ",
      show: true,
      row: row,
    });
  };

  const confirmCreateProviderUser = () => {
    handleNavigateToCreateUser(createProviderUser.row);
    setCreateProviderUser({ message: "", show: false, row: "" });
  };

  const handleNavigateToCreateUser = (row: any) => {
    dispatch(setSelectedModule("User")); 
    navigate("/user_create", { state: { providerData: { providerId: row.providerId, entityIds: practiceEditInfo?.practiceId } } });
  };
  const cancelCreateProviderUser = () => {
    setCreateProviderUser({ message: "", show: false, row: "" });
  };

  //CS-1234 - Start
  const productOptions = useMemo(() => {
    let options: Option[] = [];
    if (productsByUserRole) {
      const sortedProductList: ProductInfo[] = sortNames(productsByUserRole, 'productName');
      sortedProductList?.map((option) => {
        options.push({ label: option.manufacturerName + " - " + option.productName, value: option.productId })
      });
    };
    return options;
  }, [productsByUserRole]);

  const associateAgencyOptions = useMemo(() => {
    let options: AgencyOption[] = [];
    if (associateAgencyList) {
      const sortedAgencyList: CreateSearchAgency[] = sortNames(associateAgencyList, 'agencyName');
      sortedAgencyList?.forEach((option) => {
        if (option.agencyName !== undefined && option.agencyId !== undefined) {
          options.push({ label: option.agencyName, value: option.agencyId });
        }
      });
    };
    return options;
  }, [associateAgencyList]);

  const AssociateOptions = [PRACTICE_ENTITY, ACCOUNT_REPRESENTATIVE_ENTITY, AGENCY_ENTITY]

  const associateOptions = useMemo<Option[]>(() => {
    let options: Option[] = [];
    if (AssociateOptions && AssociateOptions.length > 0) {
      options = AssociateOptions.map((option) => ({
        value: option,
        label: option,
      }));
    }
    return options;
  }, [AssociateOptions]);

  const agencyExecutivesOptions = useMemo(() => {
    let options: any[] = [];
    agencyExecutives?.map((executive) => {
      options.push({
        value: executive.userId,
        label:
          // executive.agencyName +
          // " - " +
          fullName(
            null,
            executive.firstName,
            executive.middleName,
            executive.lastName
          ),
      });

    });

    return options;
  }, [agencyExecutives])

  const practiceListOptions = useMemo(() => {
    let options: Option[] = [];
    if (practiceByUserRoleAgencySlice && practiceByUserRoleAgencySlice.length > 0) {
      const sortedPracticeInfo: PracticeInfo[] = sortNames(practiceByUserRoleAgencySlice, 'practiceName');
      sortedPracticeInfo?.map(practice => {
        options.push({ value: practice.practiceId, label: practice.practiceName });
      });
    }
    return options;
  }, [practiceByUserRoleAgencySlice]);

  const handleSaveAgencyProductCommission = async (data: ProductCommissionAgency) => {
    let errorObj: MainErrorInfo = {
      title: "",
    };

    try {

      let response = await dispatch(editAgencyProductCommission(data));

      if (response.payload && response.payload.message === 'SUCCESS') {

        let alertMessage = editCommission ? "Agency Product Service Fee Updated Successfully!" : "Agency Product Service Fee Created Successfully!";

        const alertObj: SingleAlertInfo = {
          message: alertMessage,
          alertType: "success",
        };

        dispatch(getOverrideAgencyCommissions(location?.state?.practiceId));

        dispatch(setSingleAlertObj(alertObj));
      } else {
        let errorSentence = '';
        if (response.payload.errors.length <= 0) {
          errorSentence = response.payload.message || "An unknown error occurred.";
        } else {
          response.payload.errors.forEach((error: any, index: any) => {
            if (error.field) {
              errorSentence += `${error.field}: ${error.errorMessage}\n`;
            } else {
              errorSentence += `${error.reason}\n`;
            }
          });
        }

        errorObj.title = editCommission ? "Agency Product Service Fee Update Failed!" : "Agency Product Service Fee Creation Failed!";
        errorObj.errorMessageStream = errorSentence;
        dispatch(setMainErrorObj(errorObj));
      }
    } catch (error) {
      console.log("Error creating agency product commission :", error);
      errorObj.title = editCommission ? "Error updating agency product service fee" : "Error creating agency product service fee";
      errorObj.errorMessageStream = "" + error;
      dispatch(setMainErrorObj(errorObj));
    }
  };

  const submitCommission = (commission: ProductCommissionAgency) => {

    let updatedCommissionList: ProductCommissionAgency[] = [];

    let notValidCommission = false;
    let errorMsg = "";

    let newEffectiveDate = commission.effectiveDate ? moment(commission.effectiveDate?.toString())?.format("MM/DD/YYYY") : "";
    let newInativeDate = commission.inactiveDate ? moment(commission.inactiveDate?.toString())?.format("MM/DD/YYYY") : "";

    if (newInativeDate === "Invalid date") {
      notValidCommission = true;
      errorMsg = "Inactive Date is Invalid";
    }

    if (newEffectiveDate === "Invalid date") {
      notValidCommission = true;
      errorMsg = "Effective Date is Invalid";
    }

    if (newInativeDate !== "" && newInativeDate !== "Invalid date" && newEffectiveDate !== "Invalid date" && new Date(newEffectiveDate) > new Date(newInativeDate)) {
      notValidCommission = true;
      errorMsg = "Effective Date should be less than Inactive Date";
    }

    if (!notValidCommission) {
      const productIds = Array.isArray(commission.productId) ? commission.productId : [commission.productId];

      for (const singleProductId of productIds) {
        if (overrideAgencyCommissionsList && overrideAgencyCommissionsList.length) {
          for (let i = 0; i < overrideAgencyCommissionsList.length; i++) {
            const existingCommission: ProductCommissionAgency = overrideAgencyCommissionsList[i];

            if (!hasProductIdOverlap(existingCommission.productId, singleProductId)) {
              continue;
            }

            if (!!selectedCommission.productId && isSameRecord(selectedCommission, existingCommission)) {
              continue;
            }

            if (commission.associateAgencyId && existingCommission.associateAgencyId !== commission.associateAgencyId) {
              continue;
            }

            let existingEffectiveDate = existingCommission.effectiveDate ? moment(existingCommission.effectiveDate?.toString())?.format("MM/DD/YYYY") : "";
            let existingInactiveDate = existingCommission.inactiveDate ? moment(existingCommission.inactiveDate?.toString())?.format("MM/DD/YYYY") : "";

            if (existingInactiveDate === "" && newInativeDate === "" ||
              existingInactiveDate === "" && newInativeDate !== "" && isDateEarlier(existingEffectiveDate, newInativeDate) ||
              existingInactiveDate !== "" && newInativeDate === "" && isDateEarlier(newEffectiveDate, existingInactiveDate) ||
              isDateBetween(existingEffectiveDate, existingInactiveDate, newEffectiveDate) ||
              isDateBetween(existingEffectiveDate, existingInactiveDate, newInativeDate) ||
              isDateBetween(newEffectiveDate, newInativeDate, existingEffectiveDate)) {
              notValidCommission = true;
              errorMsg = "Valid existing service fee is exists in the system";
              break;
            }
          }
        }

        if (notValidCommission) {
          break;
        }
      }
    }
    if (notValidCommission) {
      let errorObj: MainErrorInfo = {
        title: "",
      };

      errorObj.title = editCommission ? "Error updating agency product service fee" : "Error creating agency product service fee";
      errorObj.errorMessageStream = errorMsg;
      setOpen(false);
      dispatch(setMainErrorObj(errorObj));
      return;
    }

    const productIds = Array.isArray(commission.productId) ? commission.productId : [commission.productId];
    if (overrideAgencyCommissionsList && overrideAgencyCommissionsList.length) {
      const matchingOverride: any = overrideAgencyCommissionsList.find(
        (override: any) => override.productCommissionId === commission.productCommissionId
      );
      if (Array.isArray(commission.productId)) {
        // Create separate commission entries for each product ID
        for (const singleProductId of productIds) {


          const singleCommission: ProductCommissionAgency = {
            ...commission,
            productId: singleProductId,
            agencyId: matchingOverride?.agencyId,
            inactiveDate: commission.inactiveDate ? moment(commission.inactiveDate?.toString())?.format("MM/DD/YYYY") : "",
            effectiveDate: commission.effectiveDate ? moment(commission.effectiveDate?.toString())?.format("MM/DD/YYYY") : "",
            commissionRate: commission.commissionRate ? Number(commission.commissionRate) : 0
          };

          handleSaveAgencyProductCommission(singleCommission);
        }
      } else {
        commission.agencyId = matchingOverride?.agencyId;
        commission.inactiveDate = commission.inactiveDate ? moment(commission.inactiveDate?.toString())?.format("MM/DD/YYYY") : "";
        commission.effectiveDate = commission.effectiveDate ? moment(commission.effectiveDate?.toString())?.format("MM/DD/YYYY") : "";
        commission.commissionRate = commission.commissionRate ? Number(commission.commissionRate) : 0;

        handleSaveAgencyProductCommission(commission);
      }
    }
    setOpen(false);
    setEditCommission(false);
    setSelectedAssociateType('');
  };

  const handleActionEdit = (row: Row) => {
    setEditCommission(true);
    setSelectedAssociateType(row.associateAgencyId ? "AGENCY" : row.associateType)
    // setSelectedAssociateType(row.associateType)

    const selectedCommission: Row = {
      productCommissionId: row.productCommissionId,
      productId: row.productId === undefined ? undefined : Array.isArray(row.productId) ? row.productId : [row.productId],
      productName: row.productName,
      associateType: row.associateAgencyId ? "AGENCY" : row.associateType,
      associateAgencyId: row.associateAgencyId,
      associatePracticeId: row.associatePracticeId,
      associateAccountRepId: row.associateAccountRepId,
      commissionRate: row.commissionRate ? Number(row.commissionRate.toString().split(" ")[0]) : "",
      commissionPayTerms: row.commissionPayTerms,
      associateAgencyName: row.associateAgencyName,
      associatePracticeName: row.associatePracticeName,
      associateAccountRepName: row.associateAccountRepName,
      associateAgencyCommission: row.associateAgencyCommission,
      effectiveDate: row.effectiveDate,
      inactiveDate: row.inactiveDate,
      rowIndex: row.rowIndex
    }
    setSelectedCommission(selectedCommission);
    setOpen(true);
  }
  //CS-1234 - End

  const actionComponentSignerPopup = (row: any): JSX.Element => {
    return (
      <>
        {canAccessPracticeActionsInactive && (
          row.inactiveDate === null || row.inactiveDate === "" ? (
            <>
              {/* <CustomIconButton
                color="info"
                size="small"
                variant="outlined"
                tooltipMessage="Edit"
                tooltipPlacement="top"
                onClick={() => handleEditActionLocation(row)}
              >
                <ModeOutlined fontSize="small" />
              </CustomIconButton> */}
              <CustomIconButton
                color="warning"
                size="small"
                variant="outlined"
                tooltipMessage="Inactivate"
                tooltipPlacement="top"
                onClick={() => { handleInactivateSigner(row) }}
              >
                <DoDisturbAltOutlined fontSize="small" />
              </CustomIconButton>
            </>
          ) : (
            ""
          )
        )}
      </>
    );
  };

  //CS-1234 - Start
  const overrideEntityActionComponent = (row: any): JSX.Element => {
    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          tooltipMessage="Edit"
          tooltipPlacement="top"
          onClick={() => handleActionEdit(row)}
        >
          <ModeOutlined fontSize="small" />
        </CustomIconButton>
      </>
    );
  };
  //CS-1234 - End

  //CS-1310 - Start
   // handle practice template download
  const handlePracticeTemplateDownload = async (templateId: string) => {
    if (isDownloading.current) return;
    isDownloading.current = true;

    try {
      const actionResult = await dispatch(fetchTemplateById(templateId));
      const documentData = actionResult.payload;
      if (documentData && documentData.content) {
      downloadBase64File(documentData.content, documentData.templateFileName, 'image/jpeg');
      }

    } finally {
      isDownloading.current = false;
    }
  };

  //CS-1518 START
  const practiceTemplateActionComponent = (row: any): JSX.Element => {
    const isInactive = (row.inactiveDate && row.inactiveDate.trim() !== "" ) || row.templateLevel !== 'Practice';
    
    return (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {!isInactive && (
          <CustomIconButton
            color="info"
            size="small"
            variant="outlined"
            tooltipMessage="Edit"
            tooltipPlacement="top"
            onClick={() => handleEditPracticeTemplate(row)}
          >
            <Edit fontSize="small" />
          </CustomIconButton>
        )}

        {!isInactive && (
          <CustomIconButton
            color="warning"
            size="small"
            variant="outlined"
            tooltipMessage="Inactivate"
            tooltipPlacement="top"
            onClick={() => handleInactivatePracticeTemplate(row)}
          >
            <DoDisturbAltOutlined fontSize="small" />
          </CustomIconButton>
        )}

        <CustomIconButton
          color="success"
          size="small"
          variant="outlined"
          tooltipMessage="Download"
          tooltipPlacement="top"
          onClick={() => handlePracticeTemplateDownload(row.templateId)}
        >
          <DownloadOutlined fontSize="small" />
        </CustomIconButton>
      </Box>
    );
  };

  const handleEditPracticeTemplate = (row: any) => {
    const templateData = practiceTemplateData?.find(template => template.manufacturerPracticeTemplateId === row.manufacturerPracticeTemplateId);

    if (templateData) {
      const editData: EditPracticeTemplateData = {
        manufacturerPracticeTemplateId: templateData.manufacturerPracticeTemplateId,//CS-1518
        manufacturerId: templateData.manufacturerId?.toString() || "",
        templateType: templateData.type || "",
        templateId: templateData.templateId?.toString() || ""
      };

      setTemplateEditData(editData);
      setIsTemplateEditMode(true);
      setShowTemplatePopup(true);
    }
  };

  const handleInactivatePracticeTemplate = (row: any) => {
    setShowOptionsPopup({
      message: `Are you sure you want to inactivate this practice template?`,
      show: true,
      variant: "warning",
      buttons: [
        {
          name: "Yes",
          color: 'primary',
          onClick: async () => {
            try {
              const result = await dispatch(inactivatePracticeTemplateData(row.manufacturerPracticeTemplateId));//CS-1518
              if (inactivatePracticeTemplateData.fulfilled.match(result)) {
                const successObj: SingleAlertInfo = {
                  message: "Practice Template Successfully Inactivated",
                  alertType: "success",
                };
                dispatch(setSingleAlertObj(successObj));
                // Refresh the practice templates list
                if (practiceEditInfo?.practiceId) {
                  dispatch(fetchPracticeTemplatesData(practiceEditInfo.practiceId));
                }
              } else {
                const errorObj: SingleAlertInfo = {
                  message: "Failed to inactivate practice template. Please try again.",
                  alertType: "error",
                };
                dispatch(setSingleAlertObj(errorObj));
              }
            } catch (error) {
              const errorObj: SingleAlertInfo = {
                message: "An error occurred while inactivating the practice template.",
                alertType: "error",
              };
              dispatch(setSingleAlertObj(errorObj));
            }
            setShowOptionsPopup({ message: "", show: false });
          }
        },
        {
          name: "No",
          color: 'error',
          onClick: () => {
            setShowOptionsPopup({ message: "", show: false });
          }
        }
      ]
    });
  };
  //CS-1518 END

  //CS-1310 - End
  const handleInactivateSigner = (row: any) => {
    if (row.isOwner.toLowerCase() === "yes") {
      const isLastOwner = authorizedSignersInfo.filter(signer => signer.isOwner.toLowerCase() === "yes" && !signer.inactiveDate).length === 1;
      if (isLastOwner) {
        setInactiveSigner({
          message: "At least one owner is required. Please add a new owner before inactivating this signer.",
          show: false,
          row: row,
        });
  
        let ErrObj: SingleAlertInfo = {
          message: "At least one owner is required. Please add a new owner before inactivating this signer.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(ErrObj));
      } else {
        setInactiveSigner({
          message: "Do you really want to inactive this authorized signer?",
          show: true,
          row: row,
        });
      }
    } else {
      setInactiveSigner({
        message: "Do you really want to inactive this authorized signer?",
        show: true,
        row: row,
      });
    }
  };
  
  const confirmInactiveSigner = () => {
    handleDeleteActionSigner(inactiveSigner.row);
    setInactiveSigner({ message: "", show: false, row: null });
  };
  
  const cancelInactiveSigner = () => {
    setInactiveSigner({ message: "", show: false, row: "" });
  };
  
  const handleDeleteActionSigner = async (row: any) => {
    const currentDate = new Date();
    const formattedDate = moment(currentDate).format("MM/DD/YYYY");
    const data = {
      practiceId: practiceEditInfo?.practiceId,
      fullName: row.fullName,
      isOwner: row.isOwner,
      title: row.title,//CS-1425 
      position: row.position,
      email: row.email,
      inactiveDate: formattedDate,
    };
    const response = await dispatch(inactiveAuthorizedSigner({request:data , interceptorOption: { skipErrorPopup: true }}));
    if (practiceEditInfo) {
      if (
        response.payload !== undefined &&
        response.payload.message === "SUCCESS"
      ) {
        let successObj: SingleAlertInfo = {
          message: "Authorized Signer Successfully Inactivated",
          alertType: "success",
        };
        
        dispatch(setSingleAlertObj(successObj));
        dispatch(fetchPracticeByIdData(practiceEditInfo.practiceId));
      } else if (response.payload !== undefined && response.payload.message) {
        let errorObj: SingleAlertInfo = {
          message: response.payload.message,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      } else {
        let errorObj: SingleAlertInfo = {
          message: "Authorized Signer Inactive Failed.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      }
    }
  };

  const actionComponentLocationPopup = (row: any): JSX.Element => {
    return (
      <>
        {row.inactiveDate === null || row.inactiveDate === "" ? (
          <>
            {/* <CustomIconButton
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Edit"
              tooltipPlacement="top"
              onClick={() => handleEditActionLocation(row)}
            >
              <ModeOutlined fontSize="small" />
            </CustomIconButton> */}
            <CustomIconButton
              color="warning"
              size="small"
              variant="outlined"
              tooltipMessage="Inactivate"
              tooltipPlacement="top"
              onClick={() => {handleInactivateBillingAddress(row)}}
            >
              <DoDisturbAltOutlined fontSize="small" />
            </CustomIconButton>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const actionComponentProviderPopup = (row: any): JSX.Element => {
    return (
      <>
        {row.inactiveDate === null || row.inactiveDate === "" ? (
          <>
            {/* <CustomIconButton
              color="info"
              size="small"
              variant="outlined"
              tooltipMessage="Edit"
              tooltipPlacement="top"
              onClick={() => handleEditActionProvider(row)}
            >
              <ModeOutlined fontSize="small" />
            </CustomIconButton> */}
            <CustomIconButton
              color="warning"
              size="small"
              variant="outlined"
              tooltipMessage="Inactivate"
              tooltipPlacement="top"
              onClick={() => {handleInactivateProvider(row)}} 
            >
              <DoDisturbAltOutlined fontSize="small" />
            </CustomIconButton>
            {!row.isExistingUserProfile && (
              <CustomIconButton
                color="success"
                size="small"
                variant="outlined"
                tooltipMessage="Create User Account"
                tooltipPlacement="top"
                onClick={() => { handleCreateProviderUser(row) }}
              >
                <PersonAddAltOutlined fontSize="small" />
              </CustomIconButton>
            )}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const clickShowLocationPopup = () => {
    setLocationItemObject(initialState);
    setShowLocationPopup(true);
  };

  const clickClosePracticesPopup = () => {
    setShowLocationPopup(false);
  };

  const clickShowProviderPopup = () => {
    setProviderItemObject(providerInitialState);
    setShowProviderPopup(true);
  };

  const clickCloseProviderPopup = () => {
    setShowProviderPopup(false);
  };

  const clickShowAuthorizedSignerPopup = () => {
    setShowAuthorizedSignerPopup(true);
  };

  const clickCloseAuthorizedSignerPopup = () => {
    setShowAuthorizedSignerPopup(false);
  };

  const clickShowTemplatePopup = () => {
    setIsTemplateEditMode(false);
    setTemplateEditData(undefined);
    setShowTemplatePopup(true);
  };

  const clickCloseTemplatePopup = () => {
    setShowTemplatePopup(false);
    setIsTemplateEditMode(false);
    setTemplateEditData(undefined);
  };

  const addPractice = async (practiceLocation: PracticeLocationInfo) => {

    // if (practiceLocation.isBillingAddress === "yes") {
    //   const hasBillingAddress = modifiedPracticeLocationInfo.some(
    //     (location) => location.locationType === "BILLING"
    //   );

    //   if (hasBillingAddress && practiceLocation.locationId === undefined) {
    //     let errorObj: SingleAlertInfo = {
    //       message:
    //         "There's already a practice location marked as the billing address. Please update the existing location instead.",
    //       alertType: "error",
    //     };
    //     dispatch(setSingleAlertObj(errorObj));
    //     return;
    //   }
    // }

    if (practiceEditInfo) {
      const modifiedPracticeLocation = {
        ...practiceLocation,
        practiceId: practiceEditInfo.practiceId,
      };
      const response = await dispatch(
        savePracticeLocations(modifiedPracticeLocation)
      );
      if (
        response.payload !== undefined &&
        response.payload.message === "SUCCESS"
      ) {
        let successObj: SingleAlertInfo = {
          message:
            practiceLocation.locationId === undefined
              ? "Practice Location Successfully Added."
              : "Practice Location Successfully Updated",
          alertType: "success",
        };
        setPracticeUpdated(true);
        dispatch(setSingleAlertObj(successObj));
        dispatch(fetchPracticeLocationsData(practiceEditInfo.practiceId));
      } else if (response.payload !== undefined && response.payload.message) {
        let errorObj: SingleAlertInfo = {
          message: response.payload.message,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      } else {
        let errorObj: SingleAlertInfo = {
          message: "Practice Location Adding Failed.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      }
    }
  };

  const addProvider = async (provider: PracticeProviderInfo) => {
    if (practiceEditInfo) {
      const modifiedPracticeProvider = {
        ...provider,
        practiceId: practiceEditInfo.practiceId,
      };
      const response = await dispatch(
        savePracticeProviders(modifiedPracticeProvider)
      );
      if (
        response.payload !== undefined &&
        response.payload.message === "SUCCESS"
      ) {
        let successObj: SingleAlertInfo = {
          message:
            provider.providerId === undefined
              ? "Practice Provider Successfully Added."
              : "Practice Provider Successfully Updated.",
          alertType: "success",
        };
        setPracticeUpdated(true);
        dispatch(setSingleAlertObj(successObj));
        dispatch(fetchPracticeProvidersData(practiceEditInfo.practiceId));
      } else if (response.payload !== undefined && response.payload.message) {
        let errorObj: SingleAlertInfo = {
          message: response.payload.message,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      } else {
        let errorObj: SingleAlertInfo = {
          message: "Practice Provider Adding Failed.",
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      }
    }
  };

  const addSigner = async (signer: AuthorizedSignerInfo) => {
    console.log("%c Line:1169 🍢 signer", "color:#7f2b82", signer);
    if (practiceEditInfo) {
      const modifiedSigner:any = {
        ...signer,
        practiceId: practiceEditInfo.practiceId,
      };
      const response = await dispatch(saveAuthorizedSigners({data : modifiedSigner, interceptorOption: { skipErrorPopup: true }}));
      if (
        response.payload !== undefined &&
        response.payload.message === "SUCCESS"
      ) {
        let successObj: SingleAlertInfo = {
          message:"Authorized Signer Successfully Added.",
            // signer.signerId === undefined
            //   ? "Authorized Signer Successfully Added."
            //   : "Authorized Signer Successfully Updated.",
          alertType: "success",
        };
        
        dispatch(setSingleAlertObj(successObj));
        dispatch(fetchPracticeByIdData(practiceEditInfo.practiceId));
      } 
      else if (response.payload !== undefined && response.payload.message) {
        let errorObj: SingleAlertInfo = {
          message: response.payload.message,
          alertType: "error",
        };

        dispatch(setSingleAlertObj(errorObj));
        return;
      } else {
        let errorObj: SingleAlertInfo = {
          message: "Authorized Signer Adding Failed." ,
          alertType: "error",
        };
        dispatch(setSingleAlertObj(errorObj));
      }
    }
  };

  //CS-1395 - Start
  const updateAuthorisedUser = async (id:any , data:any) => {
    let errorObj: MainErrorInfo = {
      title: "",
    };
    const updatedData = {
      practiceId: data?.practiceId,
      providerId: data?.providerId ? data?.providerId : null,
      providerAuthorizedUserId: id,
      userId: data?.authorisedUserList[0]?.userId,
      isNotificationEnabled: data?.authorisedUserList[0]?.isNotificationEnabled
    }
    if(updatedData){
      const response  = await dispatch(editAuthorizedProviderUserData(updatedData))
      if(response.payload && response.payload.message === "SUCCESS"){
        let successObj: SingleAlertInfo = {
          message: "Authorized Provider User Successfully Updated.",
          alertType: "success",
        };
        dispatch(setSingleAlertObj(successObj));
        await dispatch(fetchAllAuthorizedProviderUserData(updatedData.practiceId))
      }else{
         let errorSentence = '';
        if (response.payload.errors.length <= 0) {
          errorSentence = response.payload.message || "An unknown error occurred.";
        } else {
          response.payload.errors.forEach((error: any, index: any) => {
            if (error.field) {
              errorSentence += `${error.field}: ${error.errorMessage}\n`;
              if (error.field === 'email') {
                setError('email', {
                  type: 'manual',
                  message: error.errorMessage,
                });
              }
            } else {
              errorSentence += `${error.reason}\n`;
            }
          });
        }
         errorObj.title = "Authorized Provider User Is Already Selected.";
         errorObj.errorMessageStream = errorSentence;
          dispatch(setMainErrorObj(errorObj));
      }
    }
   
  }
  const addAuthorisedUser = async (userData: any) => {
     let errorObj: MainErrorInfo = {
          title: "",
        };
    
    if (userData) {
      const response = await dispatch(addAuthorizedProviderUserData(userData));
      if (
        response.payload !== undefined &&
        response.payload.message === "SUCCESS"
      ) {
        let successObj: SingleAlertInfo = {
          message: "Authorized Provider User Successfully Added.",
          alertType: "success",
        };
        dispatch(setSingleAlertObj(successObj));
        await dispatch(fetchAllAuthorizedProviderUserData(location.state.practiceId))
      }else{
        let errorSentence = '';
        if (response.payload.errors.length <= 0) {
          errorSentence = response.payload.message || "An unknown error occurred.";
        } else {
          response.payload.errors.forEach((error: any, index: any) => {
            if (error.field) {
              errorSentence += `${error.field}: ${error.errorMessage}\n`;
              if (error.field === 'email') {
                setError('email', {
                  type: 'manual',
                  message: error.errorMessage,
                });
              }
            } else {
              errorSentence += `${error.reason}\n`;
            }
          });
        }

        errorObj.title = "Authorized Provider User Already Added!";
        errorObj.errorMessageStream = errorSentence;
        dispatch(setMainErrorObj(errorObj));
      }
    }
  }
  //CS-1395 - End

  const addPracticeTemplate = async () => {
    if (practiceEditInfo) {
      // This function is called as a callback from the popup
      // The actual API call is handled within the popup component
      // const response = await dispatch(addPracticeTemplate({
      //   practiceId: practiceEditInfo.practiceId,
      //   manufacturerId: templateData.manufacturerId,
      //   templateType: templateData.templateType
      // }));

      // if (response.payload && response.payload.message === "SUCCESS") {
      //   let successObj: SingleAlertInfo = {
      //     message: "Practice Template Successfully Added.",
      //     alertType: "success",
      //   };
      //   dispatch(setSingleAlertObj(successObj));
      //   dispatch(fetchPracticeTemplatesData(practiceEditInfo.practiceId));
      // }
    }
  };

  const handleSignerChange = (name: string, value: string) => {
  };

  const handleProviderChange = (name: string, value: string) => {
    setProvider((prevPro) => ({
      ...prevPro,
      [name]: value,
    }));
  };

  //modify practice locations object array to display the combined address
  const modifiedPracticeLocationInfo = useMemo(() => {
    if (practiceLocationsInfo) {
      return practiceLocationsInfo.map((info) => ({
        ...info,
        combinedAddress: `${info.streetAddress}${info.unitNumber ? ', ' + info.unitNumber : ''}${info.city ? ', ' + info.city : ''}${info.state ? ', ' + info.state : ''}${info.zipCode ? ', ' + info.zipCode : ''}`,
        modifiedInactiveDate:
          info.inactiveDate !== null
            ? moment(info.inactiveDate).format("MM/DD/YYYY")
            : "",
        billingAddress: info.locationType === "BILLING" ? "Yes" : "No"
      }));
    }
    return [];
  }, [practiceLocationsInfo]);

  //modify the practice providers object array to display full name
  const modifiedPracticeProvidersInfo = useMemo(() => {
    if (!practiceProvidersInfo) return [];
    
    const mappedData = practiceProvidersInfo && practiceProvidersInfo.map((info) => {
        const isExistingUserProfile = usedPracticeProviderIds?.includes(info.providerId) ?? false;

        return {
            ...info,
          fullName: isExistingUserProfile ? (
            <Link
              component="button"
              underline="hover"
              variant="body2"
              onClick={() => handleUserListNavigate(info)}
              color={colors.info[300]}
            >
              {`${info.title ? info.title + " " : " "} ${info.firstName} ${info.middleName ? info.middleName + " " : ""
                }${info.lastName}`}
            </Link>
          ) : (
            `${info.title ? info.title + " " : " "} ${info.firstName} ${info.middleName ? info.middleName + " " : ""
            }${info.lastName}`),
            modifiedInactiveDate: info.inactiveDate 
                ? moment(info.inactiveDate).format("MM/DD/YYYY")
                : "",
            userCreated: isExistingUserProfile ? "Yes" : "No",
            isExistingUserProfile,
        };
    });
    return mappedData.sort((a, b) => {
      if (a.inactiveDate && !b.inactiveDate) return 1;
      if (!a.inactiveDate && b.inactiveDate) return -1;
      return 0;
    });
}, [practiceProvidersInfo, usedPracticeProviderIds]);

  //CS-1234 - Start
  const findProductCommission = (commission: ProductCommissionAgency) => {
    if (associateAgencyList && associateAgencyList.length > 0) {
      const associateAgency: CreateSearchAgency | undefined = associateAgencyList?.find((associateAgency: CreateSearchAgency) => commission.associateAgencyId == associateAgency.agencyId);
      if (associateAgency && associateAgency.agencyProductCommisions) {
        const associateProdComm: ProductCommissionAgency | undefined = associateAgency.agencyProductCommisions?.find((prodComm: ProductCommissionAgency) => prodComm.productId === commission.productId);
        if (associateProdComm && associateProdComm.commissionRate) {
          return associateProdComm.commissionRate;
        }
      }
    }
    return "0%";
  }

  const commissionRow: Row[] = useMemo(() => {
    let commission: Row[] = [];
    if (overrideAgencyCommissionsList) {
      let rowIndex = 0;

      overrideAgencyCommissionsList.forEach((commissionItem: ProductCommissionAgency) => {
        commission.push({
          productCommissionId: commissionItem.productCommissionId,
          productId: commissionItem.productId,
          productName: commissionItem.productName,
          associateType: commissionItem.associateType,
          associateAgencyId: commissionItem.associateAgencyId,
          associatePracticeId: commissionItem.associatePracticeId,
          associateAccountRepId: commissionItem.associateAccountRepId,
          commissionRate: commissionItem.commissionRate + " %",
          commissionPayTerms: commissionItem.commissionPayTerms,
          associateAgencyName: commissionItem.associateAgencyName,
          associateAccountRepName: commissionItem.associateAccountRepName,
          associatePracticeName: commissionItem.associatePracticeName,
          associateEntityName: commissionItem.associateAgencyName || commissionItem.associateAccountRepName || commissionItem.associatePracticeName,
          associateAgencyCommission: commissionItem.associateAgencyId ? findProductCommission(commissionItem) : "",
          overrideAgency: commissionItem.agencyName,
          effectiveDate: commissionItem.effectiveDate ? moment(commissionItem.effectiveDate?.toString())?.format("MM/DD/YYYY") : "",
          inactiveDate: commissionItem.inactiveDate ? moment(commissionItem.inactiveDate?.toString())?.format("MM/DD/YYYY") : "",
          rowIndex: rowIndex++,
        });
      });
    }
    return commission;
  }, [overrideAgencyCommissionsList, associateAgencyList]);
  //CS-1234 - End

const handleUserListNavigate = (row: any) => {
  navigate("/user_list", { state: { providerData: { firstName: row.firstName, lastName: row.lastName, entityIds: practiceEditInfo?.practiceId } } });
};

  const authorizedSignersInfo = useMemo(() => {
    if (practiceEditInfo) {
      return practiceEditInfo.practiceRequestInfo?.authorizedSigners?.map((info) => ({
        ...info,
        fullTitleName: info.title !== null ? info.title + " " + info.fullName : info.fullName,//CS-1425 
        email: info.email
      }));
    }
    return [];
  }, [practiceEditInfo]);

  // const providerAuthorizedUserDataRows = useMemo(() => {
  //   if (providerAuthorizedUserData) {
  //     return providerAuthorizedUserData?.map((info) => ({
  //       provider: info.providerName || "All Provider",
  //       providerId: info.providerId,
  //       authorisedUser: info?.users
  //         ?.map((u: any) => `${u.email} (${u.userRole})`)
  //         .join(",\n"),
  //       emailNotification: info?.isNotificationEnabled,
  //       addedBy: info?.addedBy,
  //       addedOn: info?.addedOn
  //     }));
  //   }
  //   return [];
  // }, [providerAuthorizedUserData]);

  const usedIdsSet = new Set(usedPracticeProviderIds);
  const groups = (providerAuthorizedUserData || []).map((p: any) => ({
    providerId: p.providerId,
    providerName: p.providerName || 'All',
    providerRaw: p, // keep the raw provider if needed for navigation
    hasProfile: usedIdsSet.has(p.providerId),
    users: (p.users || []).map((u: any) => ({
      email: u.email,
      userRole: u.userRole,
      addedBy: u.addedBy,
      addedOn: u.addedOn,
      isNotificationEnabled: u.isNotificationEnabled,
      providerAuthorizedUserId: u.providerAuthorizedUserId,
      userId: u.userId
    })),
  }));

  const handleDeleteAuthorizedUser = async (userId: number) => {
    const response = await dispatch(deleteAuthorizedProviderUserById(userId));
    if (response.payload && response.payload.message === "SUCCESS") {
      let successObj: SingleAlertInfo = {
        message: "Authorized User deleted successfully.",
        alertType: "success",
      };
      await dispatch(setSingleAlertObj(successObj));
      await setShowOptionsPopup({ message: "", show: false });
      await dispatch(fetchAllAuthorizedProviderUserData(location.state.practiceId));
    }
  };

  const openCreate = () =>
  setShowAuthorizedUserPopup({ open: true, mode: 'create' });

const openEdit = (g: any, u: any) =>{
  setShowAuthorizedUserPopup({
    open: true,
    mode: 'edit',
    initialValues: {
      providerAuthorizedUserId: u.providerAuthorizedUserId,
      providerId: g.providerId,
      users: [{ userId: u.userId, isNotificationEnabled: u.isNotificationEnabled }],
    },
  });}
  // const providerAuthorizedUserDataRows = useMemo<Row[]>(() => {
  // if (!providerAuthorizedUserData || providerAuthorizedUserData.length === 0) return [];

  // // group by providerId
  // const grouped = providerAuthorizedUserData.reduce((acc, cur) => {
  //   const key = String(cur.providerId);
  //   if (!acc[key]) {
  //     acc[key] = {
  //       providerId: cur.providerId,
  //       providerName: cur.providerName,
  //       users: [],
  //       // capture added/modified metadata; choose most recent by addedOn if needed
  //       addedByList: [],
  //       addedOnList: [],
  //       notificationFlags: [],
  //     };
  //   }
  //   acc[key].users.push({ userName: cur.userName, email: cur.email });
  //   acc[key].addedByList.push(cur.addedBy);
  //   acc[key].addedOnList.push(cur.addedOn);
  //   acc[key].notificationFlags.push(cur.isNotificationEnabled);
  //   return acc;
  // }, {} as Record<string, {
  //   providerId: number;
  //   providerName: string;
  //   users: { userName: string; email: string }[];
  //   addedByList: string[];
  //   addedOnList: string[];
  //   notificationFlags: boolean[];
  // }>);

  // // build one row per providerId
  // const rows: any = Object.values(grouped).map(group => {
  //   const emails = group.users.map(u => u.email).join(", ");
  //   const isAllEnabled = group.notificationFlags.every(Boolean);
  //   const isAllDisabled = group.notificationFlags.every(v => !v);
  //   const emailNotification = isAllEnabled ? "Enabled" : (isAllDisabled ? "Disabled" : "Mixed");

  //   // Decide which added/modified data to show:
  //   // - latest by addedOn (assuming format MM/DD/YYYY hh:mm a)
  //   // If parsing is needed, do a robust parse; here we pick the last item.
  //   const addedModifiedBy = group.addedByList[group.addedByList.length - 1] ?? "";
  //   const addedModifiedAt = group.addedOnList[group.addedOnList.length - 1] ?? "";

  //   return {
  //     provider: group.providerName,
  //     authorisedUser: emails,
  //     emailNotification,
  //     addedModifiedBy,
  //     addedModifiedAt,
  //   };
  // });

//   return rows;
// }, [providerAuthorizedUserData]);

  useEffect(() => {
    const totalLocations = modifiedPracticeLocationInfo.length;
    const billing = modifiedPracticeLocationInfo.filter(row => row.locationType === 'BILLING').length;
    const inactiveBilling = modifiedPracticeLocationInfo.filter(row => row.locationType === 'BILLING' && row.inactiveDate).length;

    setTotalLocationAddressRows(totalLocations);
    setBillingRows(billing);
    setInactiveBillingRows(inactiveBilling);

    if (billing > 0 && billing === inactiveBilling) {
      setLocationError('All the billing addresses are inactivated, please add a new billing address.');
    } else {
      setLocationError('');
    }
  }, [modifiedPracticeLocationInfo]);

  useEffect(() => {
    const totalProviders = modifiedPracticeProvidersInfo.length;
    const inactiveProvider = modifiedPracticeProvidersInfo.filter(row => row.inactiveDate).length;

    setTotalProvidersRows(totalProviders);
    setInactiveProvidersRows(inactiveProvider);

    if (inactiveProvider > 0 && totalProviders === inactiveProvider) {
      setProviderError('All the practice providers are inactivated, please add a new practice provider.');
    } else {
      setProviderError('');
    }
  }, [modifiedPracticeProvidersInfo]);

  useEffect(() => {
    const provider = modifiedPracticeProvidersInfo.filter(row => row.inactiveDate === null).length;
    setLastActiveProvider(!!modifiedPracticeProvidersInfo.length && provider === 1);
  }, [modifiedPracticeProvidersInfo]);

  const downloadPracticeRegistration = async () => {
    const documentId = location?.state?.documentId
    if (documentId && documentId > 0) {
      const response = await dispatch(fetchDocumentById(documentId));
      const documentData = response.payload;
      if (documentData && documentData.content) {
        setShowPDF(true);
      }
      else {
        let errorObj: SingleAlertInfo = {
          message: `Associate agreement document not exists for this practice Id ${practiceEditInfo?.practiceId} please contact administrator`,
          alertType: "info"
        }
        dispatch(setSingleAlertObj(errorObj));
      }

    } else {
      let errorObj: SingleAlertInfo = {
        message: "Not found associate agreement document",
        alertType: "error",
      };
      dispatch(setSingleAlertObj(errorObj));
    }
  };

  const contentChangedStatus = () => {
    setPracticeUpdated(true);
  }
  const handleClose = () => {
    setShowPDF(false);
  }

  //CS-1234 - Start
  const handleCloseCommissionPopup = () => {
    setOpen(false);
    setEditCommission(false);
    setSelectedAssociateType('')
  }
  //CS-1234 - End

  return (
    <>
      <PracticeLocationPopup
        onClose={clickClosePracticesPopup}
        open={showLocationPopup}
        addPractice={addPractice}
        practiceLocations={practiceLocationsInfo}
        billingAddressPanel={false}
        practiceLocationObject={locationItemObject}
      />
      <ProviderPopup
        onClose={clickCloseProviderPopup}
        open={showProviderPopup}
        addProvider={addProvider}
        onChange={handleProviderChange}
        practiceProviderObject={providerItemObject}
      />
      <AuthorizedSignerPopup
        onClose={clickCloseAuthorizedSignerPopup}
        open={showAuthorizedSignerPopup}
        addAuthorizedSigner={addSigner}
        onChange={handleSignerChange}
      />
      {/* CS-1518 - Start */}
      <PracticeTemplatePopup
        open={showTemplatePopup}
        onClose={clickCloseTemplatePopup}
        onAdd={addPracticeTemplate}
        onSuccess={() => {
          if (practiceEditInfo?.practiceId) {
            dispatch(fetchPracticeTemplatesData(practiceEditInfo.practiceId));
          }
        }}
        practiceId={practiceEditInfo?.practiceId}
        editData={templateEditData}
        isEditMode={isTemplateEditMode}
      />
      {/* CS-1518 - End */}
      <Box sx={{ mx: { xs: "10px", sm: "20px" }, mt: "12px", pb: { xs: 8, sm: 10 }, overflow: "visible" }}>
        <CustomAlert
          open={isAlertShow}
          onClose={() => {
            setIsAlertShow(false);
          }}
          severity="info"
          message="Feature currently under development. Stay tuned for updates!"
        />
        <Box mb={1.5} display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={1}>
          <Box data-testid="header">
            <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
              Practices / Edit
            </Typography>
            <Typography component="h1" sx={{ fontSize: { xs: "1.35rem", sm: "1.6rem" }, fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1 }}>
              Practice View
            </Typography>
            <Typography sx={{ fontSize: "0.78rem", color: mTokens.textSecondary, mt: 0.4 }}>
              Update practice information, contacts, locations, and settings.
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
        <PracticeEditViewForm activeStep={activeStep} contentChangedStatus={contentChangedStatus} />
        <BillerInfoEditViewForm contentChangedStatus={contentChangedStatus} />
        {userInfo.entityName === USER_ROLE_ENTITY_NAMES.ADMIN && (
          <PracticeExecutiveInfoViewForm contentChangedStatus={contentChangedStatus} />
        )}

        <Box sx={{ pt: 0.75 }}>
          <SectionTabNav tabs={tableTabs} activeTab={selectedTableTab} onTabChange={setActiveTableTab} />
        </Box>

        {/* CS-1310 - Start */}
        {selectedTableTab === "templates" && isAdminUser && (
          <Box sx={cardSx}>
            <SectionHeader
              icon={<DescriptionOutlined fontSize="small" />}
              title="Practice Templates"
              subtitle="Add and manage templates associated with this practice."
              action={
                <Button
                  startIcon={<AddCircleOutlineOutlined />}
                  onClick={clickShowTemplatePopup}
                  variant="outlined"
                  removeUpperCase
                  sx={sectionActionBtnSx()}
                >
                  {practiceTemplateRows?.length === 0 ? "Add" : "Add More"}
                </Button>
              }
            />
            <Box sx={sectionBodySx}>
              <Box sx={{ overflowX: "auto" }}>
                <MuiCustomTable
                  sx={woundTableWrapSx}
                  columns={columnsTemplate}
                  rows={practiceTemplateRows}
                  disablePagination={true}
                  actionComponent={(row: PracticeTemplateRow[]) =>
                    practiceTemplateActionComponent(row)
                  }
                />
              </Box>
            </Box>
          </Box>
        )}
        {/* CS-1310 - End */}
        {/* CS-1234 - Start */}
        {selectedTableTab === "override" && isAdminUser && (
          <Box sx={cardSx}>
            <SectionHeader icon={<TrackChanges fontSize="small" />} title="Override Entity" subtitle="Review override agency service fees for this practice." />
            <Box sx={sectionBodySx}>
              <Box sx={{ overflowX: "auto" }}>
                <MuiCustomTable
                  sx={woundTableWrapSx}
                  columns={overrideEntityColumns}
                  rows={commissionRow ? commissionRow : []}
                  disablePagination={true}
                  actionComponent={(row: any) =>
                    canAccessPracticeActionsInactive ? overrideEntityActionComponent(row) : <></>
                  }
                />
              </Box>
            </Box>
          </Box>
        )}
        {/* CS-1234 - End */}

        {selectedTableTab === "signers" && (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1.25, alignItems: "stretch" }}>
          <Box sx={cardSx}>
            <SectionHeader
              icon={<GroupsOutlined fontSize="small" />}
              title="Authorized Signers"
              subtitle="Add authorized signers for this practice."
              action={
                <Button
                  startIcon={<AddCircleOutlineOutlined />}
                  onClick={clickShowAuthorizedSignerPopup}
                  variant="outlined"
                  removeUpperCase
                  sx={sectionActionBtnSx()}
                >
                  Add More
                </Button>
              }
            />
            <Box sx={sectionBodySx}>
              <Box sx={{ overflowX: "auto" }}>
                <MuiCustomTable
                  sx={woundTableWrapSx}
                  columns={columns4}
                  rows={authorizedSignersInfo?authorizedSignersInfo:[]}
                  disablePagination={true}
                  actionComponent={(row: any) =>
                    canAccessPracticeActionsInactive ? actionComponentSignerPopup(row) : <></>
                  }
                />
              </Box>
            </Box>
          </Box>
          <Box sx={cardSx}>
            <SectionHeader
              icon={<PlaceOutlined fontSize="small" />}
              title="Locations"
              subtitle="Add practice and billing locations."
              action={
                <Button
                  startIcon={<AddCircleOutlineOutlined />}
                  onClick={clickShowLocationPopup}
                  variant="outlined"
                  removeUpperCase
                  sx={sectionActionBtnSx(billingRows > 0 && billingRows === inactiveBillingRows ? mTokens.error : mTokens.accent)}
                >
                  Add More
                </Button>
              }
            />
            <Box sx={sectionBodySx}>
              {locationError && (
                <Typography color="error" sx={{ mb: 1, textAlign: "center" }}>
                  {locationError}
                </Typography>
              )}
              <Box sx={{ overflowX: "auto" }}>
                <MuiCustomTable
                  sx={woundTableWrapSx}
                  columns={columns}
                  rows={modifiedPracticeLocationInfo}
                  actionComponent={(row: any) =>
                    actionComponentLocationPopup(row)
                  }
                  disablePagination={true}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        )}
        {selectedTableTab === "authorizedUsers" && (
            <Box sx={cardSx}>
                <SectionHeader
                  icon={<GroupsOutlined fontSize="small" />}
                  title="Authorized User To Sign On Provider’s Behalf"
                  subtitle="Assign users who can sign on a provider’s behalf."
                  action={canAccessPracticeProviderUserActionsAddButton ? (
                    <Button startIcon={<AddCircleOutlineOutlined />} onClick={() => openCreate()} variant="outlined" removeUpperCase sx={sectionActionBtnSx()}>
                      {groups?.length === 0 ? "Add" : "Add More"}
                    </Button>
                  ) : undefined}
                />
                <Box sx={{ ...sectionBodySx, p: 0 }}>
                  {groups?.length === 0 ? (
                    <Box
                      sx={{
                        py: 2,
                        px: 2,
                        textAlign: 'center',
                      }}
                    >
                      <Typography sx={{ fontSize: "0.9rem", color: mTokens.textSecondary }}>
                        No data found
                      </Typography>
                    </Box>
                  ) : (
                    <>
                    {groups.map((g:any) => (
                    <Accordion key={g.providerId}  disableGutters square sx={{ bgcolor: 'transparent', mt: 0.75, mb: 0.75, mx: 1.25, borderRadius: "10px", border: `1px solid ${mTokens.border}` }}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                          {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%', flexWrap: 'wrap' }}>
                            <Box sx={{ flex: 1, minWidth: 200 }}>
                              {g.hasProfile && canAccessUsersList && canAccessProvidersList ? (
                                <Link
                                  component="button"
                                  underline="hover"
                                  variant="h6" sx={{ fontWeight: 800 }}
                                  color={mTokens.accent}
                                  onClick={(e) => {
                                    e.stopPropagation(); // don’t toggle accordion when clicking link
                                    handleUserListNavigate(g.providerRaw);
                                  }}
                                >
                                  {g.providerName}
                                </Link>
                              ) : (
                                <Typography variant="h6" sx={{ fontWeight: 800 }}>{g.providerName}</Typography>
                              )}
                            </Box>

                            <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: { xs: 'normal', md: 'nowrap' } }}>
                            <span style={{color:"#66BB6A", fontWeight:"bold",fontSize:"14px"}}> {g.users.length} </span> Authorized Users
                            </Typography>
                          </Box> */}
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              width: '100%',
                              flexWrap: 'nowrap',        // keep everything on one line
                            }}
                          >
                            <Box
                              sx={{
                                flex: 1,
                                minWidth: 0,              // allow this flex item to shrink in flexbox
                                display: 'inline-flex',
                                alignItems: 'baseline',
                                gap: 0.5,
                              }}
                            >
                              <Typography component="span">Provider:</Typography>

                              {g.hasProfile && canAccessUsersList && canAccessProvidersList ? (
                                <Link
                                  component="button"
                                  underline="hover"
                                  variant="h6" sx={{ fontWeight: 800 }}
                                  color={mTokens.accent}
                                  onClick={(e) => {
                                    e.stopPropagation(); // don’t toggle accordion when clicking link
                                    handleUserListNavigate(g.providerRaw);
                                  }}
                                >
                                  {g.providerName}
                                </Link>
                              ) : (
                                <Typography variant="h6" sx={{ fontWeight: 800 }}>{g.providerName}</Typography>
                              )}
                            </Box>

                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ whiteSpace: 'nowrap' }}  // keep count on same line
                            >
                              <span style={{ color: '#66BB6A', fontWeight: 'bold', fontSize: '14px' }}>
                                {g.users.length}
                              </span>{' '}
                              Authorized User(S)
                            </Typography>
                          </Box>
                        </AccordionSummary>

                      <AccordionDetails sx={{ p: 0 }}>
                        {/* <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: '40%', color:"#00B8D9", fontWeight:"bold", fontSize:"0.800rem"}}>Authorized User</TableCell>
                              <TableCell sx={{ width: '15%', color:"#00B8D9", fontWeight:"bold", fontSize:"0.800rem"}}>Email Notification</TableCell>
                              <TableCell sx={{ width: '15%', color: "#00B8D9", fontWeight:"bold", fontSize:"0.800rem"}}>Added/Modified By</TableCell>
                              <TableCell sx={{ width: '20%', color: "#00B8D9", fontWeight:"bold", fontSize:"0.800rem"}}>Added/Modified At</TableCell>
                              <TableCell sx={{ width: '10%', color: "#00B8D9", fontWeight:"bold", fontSize:"0.800rem"}}>Actions</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {g.users.map((u: any, idx: number) => (
                              <TableRow key={`${g.providerId}-${idx}`}>
                                <TableCell sx={{ width: '40%' }}>
                                  <Typography>{u.email} ({u.userRole})</Typography>
                                </TableCell>

                                <TableCell sx={{ width: '15%' }}>
                                  <Typography sx={{ color: u.isNotificationEnabled ? "#1aa457" : 'red' }}>{u.isNotificationEnabled ? 'True' : 'False'}</Typography>
                                </TableCell>

                                <TableCell sx={{ width: '15%' }}>{u.addedBy}</TableCell>
                                <TableCell sx={{ width: '20%' }}>{u.addedOn}</TableCell>

                                <TableCell sx={{ width: '10%' }}>
                                   <CustomIconButton
                                    color="info"
                                    size="small"
                                    variant="outlined"
                                    tooltipMessage="Edit"
                                    tooltipPlacement="top"
                                    onClick={() => {openEdit(g, u)}}
                                  >
                                    <Edit fontSize="small" />
                                  </CustomIconButton>

                                  <CustomIconButton
                                    color="warning"
                                    size="small"
                                    variant="outlined"
                                    tooltipMessage="Delete"
                                    tooltipPlacement="top"
                                    onClick={() => {
                                      setShowOptionsPopup({
                                        message: "Are you sure to delete the Authorized Provider User?",
                                        show: true,
                                        variant: "danger",
                                        buttons: [
                                          {
                                            name: "OK", color: "success", onClick: () => {handleDeleteAuthorizedUser(u.providerAuthorizedUserId)}
                                          },
                                          { name: "Cancel", color: "secondary", onClick: () => {setShowOptionsPopup({ message: "", show: false })}},
                                        ],
                                      });
                                    }}
                                  >
                                    <Delete fontSize="small" />
                                  </CustomIconButton>
                                 
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table> */}
                          <Box
                            sx={{
                              ...woundTableWrapSx,
                              overflowX: 'auto',
                              mx: 1.25,
                              mb: 1.25,
                              border: `1px solid ${mTokens.border}`,
                              borderRadius: '12px',
                            }}
                          >
                            <Table stickyHeader sx={{ minWidth: 720, background: "transparent !important" }}>
                              <TableHead>
                                <TableRow>
                                  <TableCell sx={{ width: { xs: '50%', md: '40%' } }}>
                                    Authorized User
                                  </TableCell>
                                  <TableCell sx={{ width: { xs: '22%', md: '15%' } }}>
                                    Email Notification
                                  </TableCell>
                                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' }, width: '15%' }}>
                                    Added/Modified By
                                  </TableCell>
                                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' }, width: '20%' }}>
                                    Added/Modified At
                                  </TableCell>
                                  {(canAccessPracticeProviderUserActionsEditButton || canAccessPracticeProviderUserActionsDeleteButton) && (<>
                                  <TableCell sx={{ width: { xs: '28%', md: '10%' }, textAlign: { xs: 'right', md: 'left' } }}>
                                    Actions
                                  </TableCell>
                                  </>)}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {g.users.map((u: any, idx: number) => (
                                  <TableRow key={`${g.providerId}-${idx}`}>
                                    <TableCell>
                                      <Typography>{u.email} ({u.userRole})</Typography>
                                      {/* Show hidden meta stacked under user on small screens */}
                                      <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 0.5 }}>
                                        <Typography variant="caption" color="text.secondary">By: {u.addedBy}</Typography><br />
                                        <Typography variant="caption" color="text.secondary">At: {u.addedOn}</Typography>
                                      </Box>
                                    </TableCell>
                                    <TableCell>
                                      <Typography sx={{ color: u.isNotificationEnabled ? '#1aa457' : 'red' }}>
                                        {u.isNotificationEnabled ? 'Yes' : 'No'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{u.addedBy}</TableCell>
                                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{u.addedOn}</TableCell>
                                    {(canAccessPracticeProviderUserActionsEditButton || canAccessPracticeProviderUserActionsDeleteButton) && (<>
                                      <TableCell sx={{ textAlign: { xs: 'right', md: 'left' } }}>
                                        {canAccessPracticeProviderUserActionsEditButton && (
                                          <CustomIconButton
                                            color="info"
                                            size="small"
                                            variant="outlined"
                                            tooltipMessage="Edit"
                                            tooltipPlacement="top"
                                            onClick={() => { openEdit(g, u) }}
                                          >
                                            <Edit fontSize="small" />
                                          </CustomIconButton>
                                        )}
                                        {canAccessPracticeProviderUserActionsDeleteButton && (
                                          <CustomIconButton
                                            color="error"
                                            size="small"
                                            variant="outlined"
                                            tooltipMessage="Delete"
                                            tooltipPlacement="top"
                                            onClick={() => {
                                              setShowOptionsPopup({
                                                message: `Authorized user will be removed from the selection. Do you wish to proceed?`,
                                                show: true,
                                                variant: "warning",
                                                buttons: [
                                                  { name: "Yes", color: 'primary', onClick: () => { handleDeleteAuthorizedUser(u.providerAuthorizedUserId) } },
                                                  { name: "No", color: 'error', onClick: () => { setShowOptionsPopup({ message: "", show: false }) } }
                                                ]
                                              });
                                            }}
                                          >
                                            <Delete fontSize="small" />
                                          </CustomIconButton>
                                        )}
                                      </TableCell>
                                    </>)}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                    </>
                  )}
                  
                </Box>
              </Box>
        )}
        {selectedTableTab === "providers" && (
            <Box sx={cardSx}>
              <SectionHeader
                icon={<LocalHospitalOutlined fontSize="small" />}
                title="Providers"
                subtitle="Add and manage providers for this practice."
                action={
                  <Button
                    startIcon={<AddCircleOutlineOutlined />}
                    onClick={clickShowProviderPopup}
                    variant="outlined"
                    removeUpperCase
                    sx={sectionActionBtnSx(inactiveBillingRows > 0 && totalProvidersRows === inactiveProvidersRows ? mTokens.error : mTokens.accent)}
                  >
                    Add More
                  </Button>
                }
              />
              <Box sx={sectionBodySx}>
                {providerError && (
                  <Typography color="error" sx={{ mb: 1, textAlign: "center" }}>
                    {providerError}
                  </Typography>
                )}
                <Box sx={{ overflowX: "auto" }}>
                  <MuiCustomTable
                    sx={woundTableWrapSx}
                    columns={columns2}
                    rows={
                      modifiedPracticeProvidersInfo
                        ? modifiedPracticeProvidersInfo
                        : []
                    }
                    actionComponent={(row: any) =>
                      actionComponentProviderPopup(row)
                    }
                    disablePagination={true}
                  />
                </Box>
              </Box>
            </Box>
        )}
            <Box sx={{ pt: 0.5, pb: 1, overflow: "visible", flexShrink: 0 }}>
              <Stack direction="row" justifyContent="flex-end" flexWrap="wrap" gap={1} sx={{ overflow: "visible" }}>
                <Button
                  color="info"
                  variant="outlined"
                  removeUpperCase
                  startIcon={<FileOpenOutlined />}
                  onClick={() => {
                    downloadPracticeRegistration();
                  }}
                  sx={outlineAccentBtnSx}
                >
                  PREVIEW ARCHIVE AGREEMENT
                </Button>
                <Button
                  color="error"
                  variant="outlined"
                  removeUpperCase
                  startIcon={<CancelOutlined />}
                  onClick={() => navigate(-1)}
                  sx={footerCancelBtnSx}
                >
                  Cancel
                </Button>
              </Stack>
            </Box>
        </Box>
      </Box>
      <OptionsPopup
        open={inactiveLocation.show}
        onClose={() =>
          setInactiveLocation({ message: "", show: false, row: "" })
        }
        variant="confirm"
        message={<>{inactiveLocation.message}</>}
        buttons={[
          {
            name: "Confirm",
            color: "primary",
            onClick: confirmInactiveLocation,
          },
          {
            name: "Cancel",
            color: "secondary",
            onClick: cancelInactiveLocation,
          },
        ]}
      />
      {showAuthorizedUserPopup.open && (
        <AuthorizedUserPopup
          open={showAuthorizedUserPopup.open}
          mode={showAuthorizedUserPopup.mode}
          initialValues={showAuthorizedUserPopup.initialValues}
          onClose={() => setShowAuthorizedUserPopup({ open: false, mode: 'create' })}
          practiceId={location?.state?.practiceId}
          onCreate={addAuthorisedUser}
          onUpdate={(id, payload) => updateAuthorisedUser(id, payload)}
        />
      )}
      <OptionsPopup
        open={createProviderUser && createProviderUser.show}
        onClose={() =>
          setCreateProviderUser({ message: "", show: false, row: "" })
        }
        variant="confirm"
        message={createProviderUser.message}
        buttons={[
          {
            name: "Confirm",
            color: "primary",
            onClick: confirmCreateProviderUser,
          },
          {
            name: "Cancel",
            color: "secondary",
            onClick: cancelCreateProviderUser,
          },
        ]}
      />
      <OptionsPopup
        open={!lastActiveProvider && inactiveProvider.show}
        onClose={() =>
          setInactiveProvider({ message: "", show: false, row: "" })
        }
        variant="confirm"
        message={<>{inactiveProvider.message} <br></br> {usedPracticeProviderIds && usedPracticeProviderIds.includes(inactiveProvider.row.providerId) && "Please note: Deactivating this practice provider will also deactivate the associated user profile."}</>}
        buttons={[
          {
            name: "Confirm",
            color: "primary",
            onClick: confirmInactiveProvider,
          },
          {
            name: "Cancel",
            color: "secondary",
            onClick: cancelInactiveProvider,
          },
        ]}
      />
      <ErrorDialog
        open={lastActiveProvider && inactiveProvider.show}
        onClose={() =>
          setInactiveProvider({ message: "", show: false, row: "" })
        }
        content = {inactiveProvider.message}
      />
      <OptionsPopup
        open={inactiveSigner.show}
        onClose={() =>
          setInactiveSigner({ message: "", show: false, row: "" })
        }
        variant="confirm"
        message={<>{inactiveSigner.message}</>}
        buttons={[
          {
            name: "Confirm",
            color: "primary",
            onClick: confirmInactiveSigner,
          },
          {
            name: "Cancel",
            color: "secondary",
            onClick: cancelInactiveSigner,
          },
        ]}
      />
      <PDFViewer
        isOpen={showPDF}
        onClose={handleClose}
        fileName={document?.documentName + ""}
        title={document?.documentName + ""}
        base64String={document?.content || ""}
      />
      {/* CS-1234 - Start */}
      <ProductCommissionPopup
        open={open}
        selectedAssociateTypeOption={selectedAssociateType}
        setSelectedAssociateType={setSelectedAssociateType}
        productOptions={productOptions}
        associateAgencyOptions={associateAgencyOptions}
        associateOptions={associateOptions}
        agencyExecutivesOptions={agencyExecutivesOptions}
        practiceListOptions={practiceListOptions}
        isCommTypeOverride={true}
        editCommission={editCommission}
        defaultValue={selectedCommission}
        handleClose={handleCloseCommissionPopup}
        submitCommission={submitCommission}
        openFrom={"PracticeEditView"}
      />
      {/* CS-1234 - End */}

      {showOptionPopup.show && (
        <OptionsPopup
          open={showOptionPopup.show}
          onClose={() => setShowOptionsPopup({ message: "", show: false })}
          variant={showOptionPopup.variant}
          message={<>{showOptionPopup.message}</>}
          buttons={showOptionPopup.buttons}
          title={showOptionPopup.title}
          obj={showOptionPopup.obj}
        />
      )}
    </>
  );
};

export default PracticeEditView;
